<template>
  <div class="chat-message">
    <!-- Avatar -->
    <div class="chat-message-avatar">
      <el-avatar class="message-avatar" :size="40" :src="avatar"></el-avatar>
    </div>


    <div class="kanjia_card">
      <div>该商品我发起了砍价</div>

      <div class="card">
        <div class="title">商品编号:{{ item.content.payload.txt }}</div>
        <div class="content">
          <div class="left">
            <el-image
                style="width: 60px; height: 60px;border-radius: 5px"
                :src="item.content.payload.thumb">
            </el-image>
          </div>
          <div class="right">
            <div class="three-line-ellipsis">
              {{ item.content.payload.title }}
            </div>
            <div class="price">{{ '¥' + item.content.payload.old_price }}</div>
          </div>
        </div>
      </div>
      <div class="text1">当前商品我很喜欢，能否以
        <span>{{ '¥' + item.content.payload.price }}</span>
        卖给我
      </div>
      <div class="btnMenu d-flex jc-between ai-center" v-if="item.content.payload.btn_show">
        <el-button type="primary" class="agree" @click="agree">同意</el-button>
        <el-button @click="disAgree">不同意</el-button>
      </div>

    </div>

    <el-dialog :modal-append-to-body="true" :append-to-body="true" :modal="true" title="" :visible.sync="dialogVisible"
               width="300px">
      <div class="kanjia_dialog">
        <div>
          <el-image
              style="width: 80px; height: 80px"
              :src="require('@/assets/images/agree.png')">
          </el-image>
        </div>

        <div class="text1">
          <span>同意议价</span>
        </div>

        <div class="text2">
          <span>确认同意当前用户发起的议价金额吗?</span>
        </div>

        <div class="btn">
          <el-button size="medium" round type="danger" @click="btnOk">确 定</el-button>
        </div>


      </div>

    </el-dialog>

    <el-dialog :modal-append-to-body="true" :append-to-body="true" :modal="true" title=""
               :visible.sync="dialogVisible_disagree" width="350px">
      <div class="kanjia_dialog">
        <div style="margin-top: 20px">
          <el-image
              style="width: 80px; height: 80px"
              :src="require('@/assets/images/disagree.png')">
          </el-image>
        </div>

        <div class="text1">
          <span>不同意议价</span>
        </div>

        <div class="text2">
          <span>确认不同意当前用户发起的议价金额吗?</span>
        </div>

        <div class="text3">
          <span>是否继续还价</span>
          <el-radio v-model="radio" label="disAgree">拒绝还价</el-radio>
          <el-radio v-model="radio" label="agree">继续还价</el-radio>
        </div>

        <div class="input" v-if="radio == 'agree'">
          <div class="text">还价金额</div>
          <el-input type="number" v-model="price" size="small" placeholder="请输入还价金额"></el-input>
        </div>

        <div class="btn">
          <el-button size="medium" round type="danger" @click="btnOk_disagree">确 定</el-button>
        </div>
      </div>

    </el-dialog>

  </div>
</template>


<script>
import {bargainPrice, sellerDickerBargain} from "@/api/app";

export default {
  name: 'ChatMessage',
  props: ['item', 'avatar'],
  emits: ['refresh'],
  inject: ['refreshSession'],
  data() {
    return {
      radio: 'agree',
      dialogVisible: false,
      dialogVisible_disagree: false,
      url_agree: require('@/assets/images/agree.png'),
      price: ''
    }
  },
  methods: {
    //同意买家的砍价
    agree() {
      this.dialogVisible = true
    },
    disAgree() {
      this.dialogVisible_disagree = true
    },

    //同意议价
    async btnOk() {
     let res = await bargainPrice({
        bargainId: this.item.content.payload.bargain_id,
        msgId: this.item.msg_id,
        status: 1 //同意
      })
      this.$emit('refresh');
      //关闭窗口
      this.dialogVisible = false
    },

    //不同意议价
    async btnOk_disagree() {
        //继续还价
        if(this.radio == 'agree') {
          await sellerDickerBargain({
            bargainId: this.item.content.payload.bargain_id,
            msgId: this.item.msg_id,
            status: 3,
            price: this.price
          })
        }else if(this.radio == 'disAgree') { //直接拒绝还价
          await bargainPrice({
            bargainId: this.item.content.payload.bargain_id,
            msgId: this.item.msg_id,
            status: 2 //拒绝
          })
        }
      this.$emit('refresh');
      //关闭窗口
      this.dialogVisible_disagree = false
    }

  },
  mounted() {
  },

}
</script>

<style lang="scss" scoped>
.chat-message {
  display: inline-flex;

  //文本超出隐藏 3行
  .three-line-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3; /* 设置为你希望的行数 */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal; /* 确保在非截断情况下可以换行 */
  }

  .chat-message-avatar {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 40px;
    height: 40px;
  }

  //砍价
  .kanjia_card {
    margin-left: 5px;
    border: 1px solid #efefef;
    padding: 10px;
    border-radius: 10px;
    max-width: 350px;
    background-color: #fff;


    .card {
      margin-top: 10px;
      background-color: #f3f3f3;
      padding: 5px 10px;
      width: 100%;
      //height: 200px;
      font-size: 14px;

      .content {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
          //width: 60px;
          //height: 60px;
          margin-right: 8px;

          image {
            border-radius: 5px;
            width: 60px;
            height: 60px;
          }
        }

        .right {
          .price {
            color: red;
            font-size: 14px;
          }
        }
      }
    }

    .text1 {
      margin-top: 5px;
      font-size: 13px;

      span {
        color: red;
      }
    }

    .btnMenu {
      margin-top: 8px;

      button {
        width: 44%;
      }

      .agree {
        background-color: #FF7B15;
        border-color: #FF7B15;
      }
    }
  }
}

.kanjia_dialog {
  //text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .text1 {
    margin-top: 30px;
    font-size: 16px;
    font-weight: bold;
  }

  .text2 {
    margin-top: 10px;
    font-size: 12px;
    color: grey;
  }

  .text3 {
    margin-top: 10px;
    color: #fe8f7f;

    span {
      display: inline-block;
      margin-right: 10px;
    }

    :deep(.is-checked) {
      .el-radio__inner {
        background-color: #fe8f7f;
        border-color: #fe8f7f;
      }

      .el-radio__label {
        color: #fe8f7f;
      }
    }

  }

  .input {
    margin-top: 20px;
    display: flex;
    align-items: center;

    .text {
      width: 80px !important;
      height: 20px;
      line-height: 20px;
    }
  }

  .btn {
    margin: 35px 0;

    :deep(.el-button) {
      width: 150px !important;
      background-color: #FF7B15;
    }
  }
}


</style>
